/**
 * 广告插入工具函数
 * 在模型列表中插入广告卡片
 */

/**
 * 在列表中插入广告
 * @param {Array} list - 模型列表
 * @param {Object} config - 配置对象
 * @param {number} config.noAdRows - 前N行不显示广告（默认4行，即16个位置）
 * @param {number} config.adFrequency - 每N行插入一个广告（默认3行，即12个位置）
 * @param {boolean} config.randomPosition - 是否随机位置（默认true）
 * @param {Function} getAdData - 获取广告数据的函数
 * @returns {Array} 插入广告后的列表
 */
export const insertAdsIntoList = (list, config = {}, getAdData) => {
  if (!list || list.length === 0 || !getAdData) {
    return list
  }

  const {
    noAdRows = 4,        // 前4行不显示广告
    adFrequency = 3,     // 每3行插入一个广告
    randomPosition = true // 随机位置
  } = config

  // 每行4个模型（lg={6}）
  const itemsPerRow = 4
  const noAdItems = noAdRows * itemsPerRow  // 前16个位置不显示广告
  const adInterval = adFrequency * itemsPerRow  // 每12个位置为一个区间

  // 创建新列表，避免修改原列表
  const newList = [...list]
  const adPositions = []

  // 计算广告插入位置
  let currentPosition = noAdItems  // 从第17个位置开始

  while (currentPosition < newList.length) {
    if (randomPosition) {
      // 随机位置：在当前区间的前8个位置中随机选择一个（避免太靠后）
      const rangeStart = currentPosition
      const rangeEnd = Math.min(currentPosition + Math.floor(adInterval * 0.7), newList.length - 1)
      if (rangeEnd >= rangeStart) {
        const randomPos = Math.floor(Math.random() * (rangeEnd - rangeStart + 1)) + rangeStart
        adPositions.push(randomPos)
      }
    } else {
      // 固定位置：每个区间的开始位置
      adPositions.push(currentPosition)
    }
    currentPosition += adInterval
  }

  // 从后往前插入，避免索引变化影响
  adPositions.reverse().forEach((position, index) => {
    const adData = getAdData()
    if (adData && position < newList.length) {
      newList.splice(position, 0, {
        isAd: true,
        adData: adData,
        id: `ad_${position}_${Date.now()}_${index}`
      })
    }
  })

  return newList
}

/**
 * 判断是否为广告项
 * @param {Object} item - 列表项
 * @returns {boolean}
 */
export const isAdItem = (item) => {
  return item && item.isAd === true
}

